import {
  getError,
  getTypeOrNull,
  useCurrentUserQuery,
} from '@spotify/confidence-graphql';

// Make it look like a standard get hook, even though we're not using
// withStandardGetHook.

export const useCurrentUser = ({ skip }: { skip?: boolean } = {}) => {
  const {
    data,
    loading,
    error: networkError,
    refetch,
  } = useCurrentUserQuery({ fetchPolicy: 'cache-first', skip });

  const currentUser = getTypeOrNull(data?.currentUser);
  const accountCreatedAt = getTypeOrNull(data?.currentAccount)?.createTime;
  const appError = getError(data?.currentUser);

  return {
    currentUser,
    accountCreatedAt,
    isLoading: loading,
    error: appError ?? networkError,
    refetch,
  };
};
